const MAX_JOINED_LENGTH = 120

// Shared by every activity kind that can affect more than one item in a single customer action
// (bulk delete, bulk move, list filter) -- keeps the same "list names if they fit, else fall back
// to a count" rule in one place rather than near-identical formats drifting apart.
export function summarizeActivityItemNames(names: ReadonlyArray<string>): string {
  if (names.length === 1) return `"${names[0]}"`
  const joined = names.map(name => `"${name}"`).join(', ')
  return joined.length <= MAX_JOINED_LENGTH ? joined : `${names.length} items`
}
